/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Pit1_TInputs */

const en_csv_to_json_pit1_t = /** @type {(inputs: Csv_To_Json_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You will need to convert types yourself`)
};

const ko_csv_to_json_pit1_t = /** @type {(inputs: Csv_To_Json_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`타입 변환은 직접 해야 합니다`)
};

const ja_csv_to_json_pit1_t = /** @type {(inputs: Csv_To_Json_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`型変換は自分で行う必要があります`)
};

/**
* | output |
* | --- |
* | "You will need to convert types yourself" |
*
* @param {Csv_To_Json_Pit1_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_pit1_t = /** @type {((inputs?: Csv_To_Json_Pit1_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Pit1_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_pit1_t(inputs)
	if (locale === "ko") return ko_csv_to_json_pit1_t(inputs)
	return ja_csv_to_json_pit1_t(inputs)
});